export default "__VITE_ASSET__KhEQzVjQ__"